module.exports = __webpack_public_path__ + "static/media/ic-camera-white.2b262f65.svg";